<template>
  <main-layout>
    <template v-if="loading">
      <div class="spinner text-xs-center" style="margin-top: 80px;">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </template>
    <template v-else>
      <v-tabs v-model="state" color="white" :slider-color="$vuetify.theme.primary" show-arrows>
        <v-tab :key="'package'" :href="'#package'" ripple>
          <span style="margin-left: 5px">{{ $t('Package') }}</span>
        </v-tab>
        <v-tab :key="'yourpackage'" :href="'#yourpackage'" ripple>
          <span style="margin-left: 5px">{{ $t('your package') }}</span>
        </v-tab>
        <v-tab :key="'redeemcode'" :href="'#redeemcode'" ripple>
          <span style="margin-left: 5px">{{ $t('Redeem Code') }}</span>
        </v-tab>
      </v-tabs>
      <div v-if="state == 'yourpackage'" class="container">
        <h2 class="mb-3">{{ $t('your package') }}</h2>

        <div class="z-border-red" v-if="account_package.includes('business')">
          <div class=" text-xs-center" style="margin-top: 15px;">
            <div style="font-size: 20px;">
              <p v-if="account_package.includes('enterprise')">
                {{ $t('You are using Enterprise Package') }}
              </p>
              <p v-else-if="account_package.includes('business')">
                {{ $t('You are using {package} Package', { package: 'BUSINESS' }) }}
              </p>
              <p v-else-if="account_package.includes('advanced')">
                {{ $t('You are using {package} Package', { package: 'ADVANCED' }) }}
              </p>
              <p
                v-else-if="
                  account_package.includes('premium') || account_package.includes('old_premium')
                "
              >
                {{ $t('You are using {package} Package', { package: 'PREMIUM' }) }}
              </p>
              <p v-else>
                {{
                  $t(
                    'You are using Basic Package, upgrade the package to use more features. Start at 500 THB/month'
                  )
                }}
              </p>
            </div>
          </div>
          <template v-if="selectedBot.pagetype != 'enterprise'">
            <div
              class=" text-xs-center"
              v-if="$store.getters.getPackage != 'premium'"
              style="margin-bottom: 15px;"
            >
              <div>
                <v-btn color="primary" @click="state = 'package'" depressed>{{
                  $t('Upgrade package')
                }}</v-btn>
              </div>
            </div>
          </template>

          <div class="hr" style="margin-bottom: 15px;"></div>
          <div style="padding: 0px 15px 15px 15px">
            <label>{{ $t('Subscription Day Remaining') }}</label>
            <h2 class="mb-2">
              <template v-if="account_package.includes('business')">
                <template v-if="selectedBot.businessExpriedTime > 0">
                  <countdown :time="selectedBot.businessExpriedTime * 1000">
                    <template slot-scope="props">
                      <template v-if="props.days">
                        {{ props.days }}
                        <span class="small">{{ $t('Days') }}</span>
                      </template>
                      <template v-else-if="props.hours > 0">
                        {{ props.hours }}
                        <span class="small">{{ $t('Hours') }}</span>
                      </template>
                      <template v-else-if="props.minutes > 0">
                        {{ props.minutes }}
                        <span class="small">{{ $t('Minutes') }}</span>
                      </template>
                      <template v-else>
                        {{ props.seconds }}
                        <span class="small">{{ $t('Seconds') }}</span>
                      </template>
                    </template>
                  </countdown>
                  <!-- {{expriedTime}}  -->
                </template>
              </template>
              <template
                v-else-if="
                  account_package.includes('premium') || account_package.includes('old_premium')
                "
              >
                <template v-if="selectedBot.expriedTime > 0">
                  <countdown :time="selectedBot.expriedTime * 1000">
                    <template slot-scope="props">
                      <template v-if="props.days">
                        {{ props.days }}
                        <span class="small">{{ $t('Days') }}</span>
                      </template>
                      <template v-else-if="props.hours > 0">
                        {{ props.hours }}
                        <span class="small">{{ $t('Hours') }}</span>
                      </template>
                      <template v-else-if="props.minutes > 0">
                        {{ props.minutes }}
                        <span class="small">{{ $t('Minutes') }}</span>
                      </template>
                      <template v-else>
                        {{ props.seconds }}
                        <span class="small">{{ $t('Seconds') }}</span>
                      </template>
                    </template>
                  </countdown>
                  <!-- {{expriedTime}}  -->
                </template>
              </template>
              <template v-else>-</template>
            </h2>
            <label>{{ $t('Expired Date') }}</label>
            <h3 class="mb-3">
              <template v-if="account_package.includes('business')">{{
                selectedBot._expireat | DateFormat('DD/MM/YYYY')
              }}</template>
              <template
                v-else-if="
                  account_package.includes('premium') || account_package.includes('old_premium')
                "
                >{{ selectedBot.expireat | DateFormat('DD/MM/YYYY') }}</template
              >
              <template v-else>-</template>
            </h3>
            <label>{{ $t('Package Options') }}</label>
            <h3 v-for="(social, index) in selectedBot.packages" :key="'package_option_' + index">
              <template v-if="social == 'facebook'">
                <i class="fab fa-facebook" style="color: #3C5A99"></i> Facebook Chatbot
              </template>
              <template v-else-if="social == 'line'">
                <i class="fab fa-line" style="color: #00c300"></i> Line Chatbot
              </template>
              <template v-else-if="social == 'google'">
                <i class="fab fa-google" style="color: #FFB306"></i> Google Chatbot
              </template>
            </h3>
          </div>
        </div>

        <div
          class="z-border-red"
          style="margin-top: 48px;"
          v-if="
            account_package.includes('advanced') &&
              selectedBot.advancedExpriedDate != selectedBot.businessExpriedDate
          "
        >
          <div class=" text-xs-center" style="margin-top: 15px;">
            <div style="font-size: 20px;">
              <p>
                {{ $t('You are using {package} Package', { package: 'ADVANCED' }) }}
              </p>
            </div>
          </div>
          <template v-if="selectedBot.pagetype != 'enterprise'">
            <div
              class=" text-xs-center"
              v-if="$store.getters.getPackage != 'premium'"
              style="margin-bottom: 15px;"
            >
              <div>
                <v-btn color="primary" @click="state = 'package'" depressed>{{
                  $t('Upgrade package')
                }}</v-btn>
              </div>
            </div>
          </template>

          <div class="hr" style="margin-bottom: 15px;"></div>
          <div style="padding: 0px 15px 15px 15px">
            <label>{{ $t('Subscription Day Remaining') }}</label>
            <h2 class="mb-2">
              <template v-if="account_package.includes('advanced')">
                <template v-if="advancedExpriedTime > 0">
                  <countdown :time="advancedExpriedTime * 1000">
                    <template slot-scope="props">
                      <template v-if="props.days">
                        {{ props.days }}
                        <span class="small">{{ $t('Days') }}</span>
                      </template>
                      <template v-else-if="props.hours > 0">
                        {{ props.hours }}
                        <span class="small">{{ $t('Hours') }}</span>
                      </template>
                      <template v-else-if="props.minutes > 0">
                        {{ props.minutes }}
                        <span class="small">{{ $t('Minutes') }}</span>
                      </template>
                      <template v-else>
                        {{ props.seconds }}
                        <span class="small">{{ $t('Seconds') }}</span>
                      </template>
                    </template>
                  </countdown>
                  <!-- {{expriedTime}}  -->
                </template>
              </template>
              <template v-else>-</template>
            </h2>
            <label>{{ $t('Expired Date') }}</label>
            <h3 class="mb-3">
              <template v-if="account_package.includes('advanced')">{{
                selectedBot.advanced_expireat | DateFormat('DD/MM/YYYY')
              }}</template>
            </h3>
            <label>{{ $t('Package Options') }}</label>
            <h3 v-for="(social, index) in selectedBot.packages" :key="'package_option_' + index">
              <template v-if="social == 'facebook'">
                <i class="fab fa-facebook" style="color: #3C5A99"></i> Facebook Chatbot
              </template>
              <template v-else-if="social == 'line'">
                <i class="fab fa-line" style="color: #00c300"></i> Line Chatbot
              </template>
              <template v-else-if="social == 'google'">
                <i class="fab fa-google" style="color: #FFB306"></i> Google Chatbot
              </template>
            </h3>
          </div>
        </div>
        <div
          class="z-border-red"
          style="margin-top: 48px;"
          v-if="
            (account_package.includes('premium') || account_package.includes('old_premium')) &&
              selectedBot.expriedDate != selectedBot.advancedExpriedDate
          "
        >
          <div class=" text-xs-center" style="margin-top: 15px;">
            <div style="font-size: 20px;">
              <p>
                {{ $t('You are using {package} Package', { package: 'PREMIUM' }) }}
              </p>
            </div>
          </div>
          <template v-if="selectedBot.pagetype != 'enterprise'">
            <div
              class=" text-xs-center"
              v-if="$store.getters.getPackage != 'premium'"
              style="margin-bottom: 15px;"
            >
              <div>
                <v-btn color="primary" @click="state = 'package'" depressed>{{
                  $t('Upgrade package')
                }}</v-btn>
              </div>
            </div>
          </template>

          <div class="hr" style="margin-bottom: 15px;"></div>
          <div style="padding: 0px 15px 15px 15px">
            <label>{{ $t('Subscription Day Remaining') }}</label>
            <h2 class="mb-2">
              <template
                v-if="
                  account_package.includes('premium') || account_package.includes('old_premium')
                "
              >
                <template v-if="selectedBot.expriedTime > 0">
                  <countdown :time="selectedBot.expriedTime * 1000">
                    <template slot-scope="props">
                      <template v-if="props.days">
                        {{ props.days }}
                        <span class="small">{{ $t('Days') }}</span>
                      </template>
                      <template v-else-if="props.hours > 0">
                        {{ props.hours }}
                        <span class="small">{{ $t('Hours') }}</span>
                      </template>
                      <template v-else-if="props.minutes > 0">
                        {{ props.minutes }}
                        <span class="small">{{ $t('Minutes') }}</span>
                      </template>
                      <template v-else>
                        {{ props.seconds }}
                        <span class="small">{{ $t('Seconds') }}</span>
                      </template>
                    </template>
                  </countdown>
                  <!-- {{expriedTime}}  -->
                </template>
              </template>
              <template v-else>-</template>
            </h2>
            <label>{{ $t('Expired Date') }}</label>
            <h3 class="mb-3">
              <template
                v-if="
                  account_package.includes('premium') || account_package.includes('old_premium')
                "
                >{{ selectedBot.expireat | DateFormat('DD/MM/YYYY') }}</template
              >
            </h3>
            <label>{{ $t('Package Options') }}</label>
            <h3 v-for="(social, index) in selectedBot.packages" :key="'package_option_' + index">
              <template v-if="social == 'facebook'">
                <i class="fab fa-facebook" style="color: #3C5A99"></i> Facebook Chatbot
              </template>
              <template v-else-if="social == 'line'">
                <i class="fab fa-line" style="color: #00c300"></i> Line Chatbot
              </template>
              <template v-else-if="social == 'google'">
                <i class="fab fa-google" style="color: #FFB306"></i> Google Chatbot
              </template>
            </h3>
          </div>
        </div>
      </div>

      <div
        v-if="
          state == 'yourpackage' &&
            selectedBot.livechatExpriedTime &&
            selectedBot.livechatExpriedTime > 0
        "
        class="container"
      >
        <div class="z-border-red">
          <div class=" text-xs-center" style="margin-top: 15px;">
            <div style="font-size: 20px;">
              <p>
                {{ $t('You are using {package} Package', { package: $t('All in one chat') }) }}
              </p>
            </div>
          </div>
          <div class="hr" style="margin-bottom: 15px;"></div>
          <div style="padding: 0px 15px 15px 15px">
            <label>{{ $t('Subscription Day Remaining') }}</label>
            <h2 class="mb-2">
              <template v-if="selectedBot.livechatExpriedTime > 0">
                <countdown :time="selectedBot.livechatExpriedTime * 1000">
                  <template slot-scope="props">
                    <template v-if="props.days">
                      {{ props.days }}
                      <span class="small">{{ $t('Days') }}</span>
                    </template>
                    <template v-else-if="props.hours > 0">
                      {{ props.hours }}
                      <span class="small">{{ $t('Hours') }}</span>
                    </template>
                    <template v-else-if="props.minutes > 0">
                      {{ props.minutes }}
                      <span class="small">{{ $t('Minutes') }}</span>
                    </template>
                    <template v-else>
                      {{ props.seconds }}
                      <span class="small">{{ $t('Seconds') }}</span>
                    </template>
                  </template>
                </countdown>
              </template>
            </h2>
            <label>{{ $t('Expired Date') }}</label>
            <h3 class="mb-3">
              <template v-if="account_package.includes('premium')">{{
                selectedBot.livechat_expireat | DateFormat('DD/MM/YYYY')
              }}</template>
            </h3>
          </div>
        </div>
      </div>

      <div
        v-if="
          state == 'yourpackage' &&
            selectedBot.googleExpriedTime &&
            selectedBot.googleExpriedTime > 0
        "
        class="container"
      >
        <div class="z-border-red">
          <div class=" text-xs-center" style="margin-top: 15px;">
            <div style="font-size: 20px;">
              <p>
                {{ $t('You are using {package} Package', { package: 'GOOGLE' }) }}
              </p>
            </div>
          </div>
          <div class="hr" style="margin-bottom: 15px;"></div>
          <div style="padding: 0px 15px 15px 15px">
            <label>{{ $t('Subscription Day Remaining') }}</label>
            <h2 class="mb-2">
              <template v-if="selectedBot.googleExpriedTime > 0">
                <countdown :time="selectedBot.googleExpriedTime * 1000">
                  <template slot-scope="props">
                    <template v-if="props.days">
                      {{ props.days }}
                      <span class="small">{{ $t('Days') }}</span>
                    </template>
                    <template v-else-if="props.hours > 0">
                      {{ props.hours }}
                      <span class="small">{{ $t('Hours') }}</span>
                    </template>
                    <template v-else-if="props.minutes > 0">
                      {{ props.minutes }}
                      <span class="small">{{ $t('Minutes') }}</span>
                    </template>
                    <template v-else>
                      {{ props.seconds }}
                      <span class="small">{{ $t('Seconds') }}</span>
                    </template>
                  </template>
                </countdown>
              </template>
            </h2>
            <label>{{ $t('Expired Date') }}</label>
            <h3 class="mb-3">
              <template v-if="account_package.includes('premium')">{{
                selectedBot.google_message_expireat | DateFormat('DD/MM/YYYY')
              }}</template>
            </h3>
          </div>
        </div>
      </div>

      <div
        v-if="
          state == 'yourpackage' &&
            selectedBot.whatsappExpriedTime &&
            selectedBot.whatsappExpriedTime > 0
        "
        class="container"
      >
        <div class="z-border-red">
          <div class=" text-xs-center" style="margin-top: 15px;">
            <div style="font-size: 20px;">
              <p>
                {{ $t('You are using {package} Package', { package: 'WHATSAPP' }) }}
              </p>
            </div>
          </div>
          <div class="hr" style="margin-bottom: 15px;"></div>
          <div style="padding: 0px 15px 15px 15px">
            <label>{{ $t('Subscription Day Remaining') }}</label>
            <h2 class="mb-2">
              <template v-if="selectedBot.whatsappExpriedTime > 0">
                <countdown :time="selectedBot.whatsappExpriedTime * 1000">
                  <template slot-scope="props">
                    <template v-if="props.days">
                      {{ props.days }}
                      <span class="small">{{ $t('Days') }}</span>
                    </template>
                    <template v-else-if="props.hours > 0">
                      {{ props.hours }}
                      <span class="small">{{ $t('Hours') }}</span>
                    </template>
                    <template v-else-if="props.minutes > 0">
                      {{ props.minutes }}
                      <span class="small">{{ $t('Minutes') }}</span>
                    </template>
                    <template v-else>
                      {{ props.seconds }}
                      <span class="small">{{ $t('Seconds') }}</span>
                    </template>
                  </template>
                </countdown>
              </template>
            </h2>
            <label>{{ $t('Expired Date') }}</label>
            <h3 class="mb-3">
              <template v-if="account_package.includes('premium')">{{
                selectedBot.whatsapp_expireat | DateFormat('DD/MM/YYYY')
              }}</template>
            </h3>
          </div>
        </div>
      </div>

      <template v-if="state == 'package'">
        <div class="swap-container">
          <div :class="{ first_div: !supporter || supporter == null }" style="width: 100%">
            <v-container
              fluid
              id="selectchatbottemplate"
              v-if="selectedBot.unlock_presets == true && false"
            >
              <h4 class="text-xs-center">{{ $t('Select a chatbot template') }}</h4>
              <presets :showBlank="false" :showSelect="false" :showCompare="true"></presets>
            </v-container>

            <div class="hr"></div>
          </div>

          <div :class="{ second_div: !supporter || supporter == null }" style="width: 100%">
            <div id="upgrade_plan" style="padding: 25px 25px;">
              <div class="row">
                <div class="col s12">
                  <view-package></view-package>
                  <v-container>
                    <template v-if="currentLang == 'en'">
                      <h3>Note:</h3>
                      <ul class="custom">
                        <li>
                          Chatbot Premium Package will get 1 Facebook Page and 1 Instagram account
                        </li>
                        <li>
                          Chatbot Advanced Package will get 1 Facebook Page, 1 Instagram account,
                          and 1 LINE OA
                        </li>
                        <li>
                          If you want to purchase more than 1 page/package,
                          <a
                            href="https://tinyurl.com/3ka4w8fa"
                            target="_blank"
                            rel="noopener noreferrer"
                            >click here</a
                          >
                        </li>
                        <li>
                          The company reserves the rights to upgrade certain features from basic to
                          premium without prior notice
                        </li>
                        <li>
                          To customize any feature or require a quotation for Chatbot, please
                          contact Email: <a href="mailto:sales@zwiz.ai">sales@zwiz.ai</a>
                        </li>
                      </ul>
                    </template>
                    <template v-if="currentLang == 'th'">
                      <strong>หมายเหตุ:</strong>
                      <ul class="custom">
                        <li>
                          แพ็กเกจพรีเมี่ยมสามารถเชื่อมแชทบอทได้ 1 เพจเฟสบุคและ 1 อินสตาแกรม
                        </li>
                        <li>
                          แพ็กเกจแอดวานซ์สามารถเชื่อมแชทบอทได้ 1 เพจเฟสบุค, 1 อินสตาแกรม, และ 1 ไลน์
                          OA
                        </li>
                        <li>
                          หากต้องการซื้อมากกว่า 1 แพ็กเกจ
                          <a
                            href="https://tinyurl.com/3ka4w8fa"
                            target="_blank"
                            rel="noopener noreferrer"
                            >คลิกเพื่อดูราคาเหมาพิเศษ</a
                          >
                        </li>
                        <li>
                          ทีมงานขอสงวนสิทธิ์ในการเปลี่ยนแปลงฟีเจอร์และปรับเบสิคแพ็กเกจโดยไม่จำเป็นต้องแจ้งล่วงหน้า
                        </li>
                        <li>
                          หากต้องการปรับแต่งฟีเจอร์เพิ่มเติมหรือต้องการใบเสนอราคา ติดต่อเราได้ที่
                          Email:
                          <a href="mailto:sales@zwiz.ai">sales@zwiz.ai</a>
                        </li>
                      </ul>
                    </template>
                    <template v-if="currentLang == 'la'">
                      <strong>ໝາຍເຫດ:</strong>
                      <ul class="custom">
                        <li>
                          ແພັກເກດພຣີມ່ຽມສາມາດເຊື່ອມແຊດບອດໄດ້ 1 ເພຈເຟດບຸກ 1 ອິນສະຕຣາແກຮມ
                        </li>
                        <li>
                          ແພັກເກດແອັດວານສາມາດເຊື່ອມແຊດບອດໄດ້ 1 ເພຈເຟດບຸກ, 1 ອິນສະຕຣາແກຮມ, ແລະ 1 ໄລນ໌
                        </li>
                        <li>
                          ຫາກຕ້ອງການຊື້ຫຼາຍກວ່າ 1 ແພັກເກດ ຄິກເພື່ອເບິ່ງລາຄາເໝົາພິເສດ
                          <a
                            href="https://tinyurl.com/3ka4w8fa"
                            target="_blank"
                            rel="noopener noreferrer"
                            >click here</a
                          >
                        </li>
                        <li>
                          ທີມງານຂໍສະຫງວນສິດໃນການປ່ຽນແປງຟີເຈີ້ແລະປັບເບສິກແພັກເກດໂດຍບໍ່ຈຳເປັນຕ້ອງແຈ້ງລ່ວງໜ້າ
                        </li>
                        <li>
                          ຫາກຕ້ອງການປັບແຕ່ງຟີເຈີ້ເພີ່ມຕື່ມຫຼືຕ້ອງການໃບສະເໜີລາຄາ ຕິດຕໍ່ເຮົາໄດ້ທີ່
                          Email:
                          <a href="mailto:sales@zwiz.ai">sales@zwiz.ai</a>
                        </li>
                      </ul>
                    </template>
                  </v-container>
                </div>
              </div>
            </div>
            <div class="hr"></div>
          </div>
        </div>

        <div style="padding: 25px 25px;">
          <div class="row">
            <div class="col s12">
              <!-- <h4 class="text-xs-center" style="margin-bottom: 25px">
                {{ $t('Premium Features') }}
              </h4> -->
              <!-- <iframe
                :src="`https://zwiz.ai/${currentLang}/featurelist`"
                frameborder="0"
                allowfullscreen
                style="    height: auto;width:100%;min-height: 700px;"
              ></iframe> -->
              <!-- <div
                style="border: 1px solid #eee; border-radius: 10px;margin-top: 15px;overflow:hidden"
              >
                <table class="table striped">
                  <thead>
                    <tr>
                      <th class="text-xs-center" style="font-size: 1.3em;width: 0">
                        {{ $t('Features') }}
                      </th>
                      <th class="text-xs-center" style="font-size: 1.3em;">{{ $t('Basic') }}</th>
                      <th class="text-xs-center" style="font-size: 1.3em;">{{ $t('premium') }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(items, k) in featureRows" :key="k">
                      <td
                        v-for="(item, i) in items"
                        :key="i"
                        class="text-xs-center"
                        :style="`${['yes', 'no'].includes(item) ? '' : 'width: 350px'}`"
                      >
                        <i v-if="item == 'yes'" class="fas fa-check" style="color: #90db26"></i>
                        <i v-else-if="item == 'no'" class="fas fa-times" style="color: red"></i>
                        <div v-else>{{ $t(item) }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </div>
          </div>
        </div>
      </template>

      <template v-if="state == 'redeemcode'" class="container">
        <redeem-code></redeem-code>
      </template>
    </template>
  </main-layout>
</template>

<script>
import api from '@/api'
import ViewPackage from '@/components/view/setting/ViewPackage'
import SupportCode from './SupportCode'
import { mapGetters } from 'vuex'
import Presets from '@/components/view/getstarted/Presets'
import RedeemCode from '@/components/view/redeem/redeemcode.vue'
import dayjs from 'dayjs'

export default {
  components: {
    ViewPackage,
    SupportCode,
    Presets,
    RedeemCode
  },
  data() {
    return {
      account_package: this.getPackageType(),
      state: 'package',
      featureRows: [
        ['Platform', 'Facebook', 'Facebook, LINE Official'],
        ['Welcome Message', 'yes', 'yes'],
        ['Extra Menu', 'yes', 'yes'],
        ['Real-time Response', 'Unlimited', 'Unlimited'],
        ['Scheduling a reply', 'yes', 'yes'],
        ['Transferring conversation to another facebook page', 'yes', 'yes'],
        ['Transferring products in shop service to another facebook page', 'no', 'yes'],
        ['Advanced Conversation', 'no', 'yes'],
        ['Conversation context', 'no', 'yes'],
        ['Status & Tag', 'no', 'yes'],
        ['Reply to a comment on posts', 'all posts', 'selected posts'],
        ['Comment to Inbox2', 'all posts', 'selected posts'],
        ['Hiding comments', 'all posts', 'selected posts'],
        ['Broadcast', 'Unlimited (Basic)', 'Unlimited (Customize)'],
        ['Scheduling a broadcast', 'no', 'yes'],
        ['Shop Service', '10 Products', 'Unlimited'],
        ['Wholesale System (shop-service)', 'no', 'yes'],
        ['In-Chat Payment', 'yes', 'yes'],
        ['Settling an invoice via chat', 'yes', 'yes'],
        ['Chat log Analytics', 'Basic', 'Customize'],
        ['Advanced CRM', 'Basic', 'Customize'],
        ['Importing previous users', 'no', 'yes'],
        ['Exporting Analytics', 'no', 'yes'],
        ['Set a timer to turn on/turn off the conversation', 'no', 'yes'],
        ['AI Training', 'no', 'yes'],
        ['Shortcut for switching chatbot mode and admin mode', 'yes', 'yes'],
        ['Shortcut # for switching to admin', 'no', 'yes'],
        ['Languages', 'TH/ENG', 'All languages'],
        ['Line Flex', 'no', 'yes'],
        ['LINE Notification', 'no', 'yes'],
        ['Support', 'Queue', 'Priority'],
        ['Creating Q&A in Reply Comment', '10 Sets Limited', 'Unlimited'],
        ['Creating Q&A in Chabot Conversation', '10 Sets Limited', '300 Sets Limited']
      ],
      supporter: null,
      loading: false,
      currentBot: null
    }
  },
  async mounted() {
    this.loading = true
    if (this.$route.query.tab) {
      this.state = this.$route.query.tab
    } else {
      this.state = 'package'
    }
    try {
      var supporter = await this.getLatestSupportUsers()
      if (supporter) this.supporter = supporter
    } catch (error) {}
    this.loading = false
    if (this.$route.hash && this.$route.hash == '#selectchatbottemplate') {
      await this.$nextTick()
      await this.wait(2000)
      this.$vuetify.goTo(this.$route.hash, {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
      })
    }
  },
  computed: {
    ...mapGetters({ currentLang: 'currentLang', selectedBot: 'selectedBot' }),
    advancedExpriedTime() {
      const vm = this
      const advancedExpriedDate = dayjs(vm.selectedBot.advanced_expireat)
      return parseInt(advancedExpriedDate.diff(dayjs(), 'seconds'))
    }
  },
  methods: {
    onUpdateSupportCode: function() {
      location.reload()
    },
    getLatestSupportUsers() {
      var data = {
        pageid: this.selectedBot.pageid
      }

      return new Promise((resolve, reject) => {
        api.getLatestSupportUsers(data, function(error, response) {
          if (error) {
            reject(error)
          } else {
            resolve(response.data && response.data.length > 0 ? response.data[0] : null)
          }
        })
      })
    },
    updateRoute: function() {
      this.$router
        .push({
          name: 'Upgrade',
          path: '/upgrade',
          query: {
            tab: this.state
          }
        })
        .catch(() => {})
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    state: function(newVal, oldVal) {
      if (newVal != oldVal) this.updateRoute()
    }
  }
}
</script>

<style lang="scss">
.zoid-outlet {
  z-index: 0 !important;
}

.swap-container {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  /* optional */
  -webkit-box-align: start;
  -moz-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.swap-container .first_div {
  -webkit-box-ordinal-group: 2;
  -moz-box-ordinal-group: 2;
  -ms-flex-order: 2;
  -webkit-order: 2;
  order: 2;
}

.swap-container .second_div {
  -webkit-box-ordinal-group: 1;
  -moz-box-ordinal-group: 1;
  -ms-flex-order: 1;
  -webkit-order: 1;
  order: 1;
}
.custom {
  padding: 0px 1%;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #212529;
  li {
    list-style: none;
  }
  li::before {
    content: '';
    display: inline-block;
    height: 13px;
    width: 13px;
    background-image: url('/static/img/assets/shop/bullet1.png');
    background-size: cover;

    margin-left: -18px;
    margin-right: 5px;
  }
  li.disable::before,
  li.disable-feature::before {
    background-image: url('/static/img/assets/shop/bullet1-disable.png');
    opacity: 0.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/Upgrade.vue